import { render, staticRenderFns } from "./AMap.vue?vue&type=template&id=15226ccf&scoped=true&"
import script from "./AMap.vue?vue&type=script&lang=js&"
export * from "./AMap.vue?vue&type=script&lang=js&"
import style0 from "./AMap.vue?vue&type=style&index=0&id=15226ccf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15226ccf",
  null
  
)

export default component.exports